import { render, staticRenderFns } from "./PdpServicesBlock.vue?vue&type=template&id=3d9a6a29&scoped=true&"
import script from "./PdpServicesBlock.vue?vue&type=script&lang=js&"
export * from "./PdpServicesBlock.vue?vue&type=script&lang=js&"
import style0 from "./PdpServicesBlock.vue?vue&type=style&index=0&id=3d9a6a29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9a6a29",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
